import React from 'react'
import BaseSearchBar from '../BaseSearchBar'

export default function UncontrolledSearchBar(props) {
  // Just to make sure this stays uncontrolled
  const { syncValue, ...rest } = props

  return <BaseSearchBar {...rest} />
}
